import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';
import { canCreateVendor } from '@/store/vendorAccess';

const CreateVendorRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  if (!canCreateVendor(authorization)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need permission to create vendors in a business unit."
      />
    );
  }
  return <>{children}</>;
};

export default CreateVendorRoute;
